import { Component } from '@angular/core';

@Component({
  templateUrl: './expander.html'  
})
export class ExpanderComponent { 
    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/expander/expander-component.ts